<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jsXD5N/Images/Cover.jpg?1739571107413" alt="This image is the cover for the book In His Eyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In His Eyes
      </h1>
      <p class="bookDescription body article font2">
        <p>Her young love for Connor Faraday had left her heartbroken. Although home designer Ellene Bordini had moved on, she'd never felt drawn to any other man — and never recovered from Connor's betrayal. Now, a decade later, Connor was back in her lifewanting her back in <i>his</i> life forever. Ellene's faith told her to forgive him and to accept the new man he'd become. While working in the brisk beauty of his Michigan island home, she rediscovered her lost love and bonded with the little girl he wanted to raise right. Was this God's mysterious way of helping Ellene deal with the pastor paving the way for reconciliation?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gail Gaymer Martin
      </h2>
      
      <p class="authorDescription body article">Award-winning novelist, Gail Gaymer Martin authored over 80 novels with 4 million books in print, receiving a Carol and 2 RT Reviewer Choice Awards. Her novel THE CHRISTMAS KITE was optioned for a Hallmark movie. Gail authored Writers Digest&#39;s WRITING THE CHRISTIAN ROMANCE and is a co-founder of American Christian Fiction Writers. CBS local news named her as the four best novelists in Detroit. Before publication, Gail worked as a counselor and a university instructor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6de1ee15